<mat-button-toggle-group name="Navegacion" aria-label="Navegación" [class.ios]="plataforma.esIos()">
  <!-- <mat-button-toggle
    *ngFor="let item of menu"
    ocultar-roles [ocultos]="item.ocultar"
    [routerLink]="[item.destino]"
    routerLinkActive="active-link"
    >{{item.nombre}}
  </mat-button-toggle> -->
  @for(item of menu; track $index){
    <a
      ocultar-roles [ocultos]="item.ocultar"
      [routerLink]="[item.destino]"
      [routerLinkActiveOptions]="{ exact: true }"
      routerLinkActive="active"
     >
    <mat-icon>{{item.icono}}</mat-icon>
    <span>{{item.nombre}}</span>
    </a>
  }
</mat-button-toggle-group>
@if(settings.margenInferior() === "true"){
  <div id="margen"></div>
}